
import React from 'react';
import isNil from 'lodash/isNil';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import { utils } from '../../../core';

import getStylesFromCssString from './getStylesFromCssString';
import getStylesFromDefinition from './getStylesFromDefinition';

const AttributeLabel = ({appConfig, definition, infoDefinition, values}) => {

    const classNames = mergeStyleSets({
        root: {
            paddingTop: 2,
            paddingBottom: 2,
            ...getStylesFromDefinition(appConfig, 'info.styles.attrContainer'),
            ...getStylesFromDefinition(infoDefinition, 'styles.attrContainer'),
            ...getStylesFromCssString(definition.containerStyles)
        },
        title: {
            width: '200px',
            minWidth: '200px',
            ...getStylesFromDefinition(appConfig, 'info.styles.attrTitle'),
            ...getStylesFromDefinition(infoDefinition, 'styles.attrTitle'),
            ...getStylesFromCssString(infoDefinition.containerStyles),
        },
        value: {
            fontWeight: 'bold',
            ...getStylesFromDefinition(appConfig, 'info.styles.attrValue'),
            ...getStylesFromDefinition(infoDefinition, 'styles.attrValue'),
        }
    });

    let value = values[definition.name];
    value = isNil(value)
        ? ''
        : '' + value;

    if (definition.template) {
        value = definition.template.replace(new RegExp(`@VALUE@`, 'g'), value);
    }

    if (definition.values) {
        value = utils.processValueWithValues(value, definition.values);
    }

    return (
        <Stack horizontal className={classNames.root}>
            <Stack.Item className={classNames.title}>
                <div>{definition.title} :</div>
            </Stack.Item>
            <Stack.Item className={classNames.value}>
                <div dangerouslySetInnerHTML={{__html: value}}></div>
            </Stack.Item>
        </Stack>
    );
}

export default AttributeLabel;
